// extracted by mini-css-extract-plugin
module.exports = {"AboutView":"AboutView_AboutView__28kEY","content":"AboutView_content__XR-V0"};